let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eBLfC")).then(() => parcelRequire('2s0Tm'));